<template>
    <div>
        <v-progress-linear
            v-if="loading"
            indeterminate
        />
        <v-card>
            <v-toolbar
                flat
                color="primary"
                dark
                dense
            >
                <v-icon left>mdi-information</v-icon>
                    Organization Info
                <v-spacer />
            </v-toolbar>
            <v-expand-transition>
                <v-card-text
                    v-if="!loading"
                >
                    <v-alert
                        :value="true"
                        type="info"
                        outline
                    >
                        Enable this option to have an "Org Info" section show up on the Contact's homepage
                    </v-alert>

                    <v-switch
                        label="Enable Organization Info"
                        v-model="orgSettings.info_enabled"
                    />

                    <Editor
                        v-show="orgSettings.info_enabled"
                        ref="htmlEditor"
                        :html="orgSettings.info"
                        :enable_html="true"
                        @changed="changed = true"
                    />
                </v-card-text>
            </v-expand-transition>
            <v-card-actions>
                <v-spacer />
                <v-btn
                    :disabled="saving || !changed"
                    color="primary"
                    @click="save"
                    @update="changed = true"
                >
                    Save
                </v-btn>
            </v-card-actions>
        </v-card>
    </div>
</template>

<script>
import api from '@/api'
import Editor from '@/components/admin/Editor'

export default{
    name: 'OrgInfo',
    data () {
        return {
            orgSettings: {},
            saving: false,
            loading: false,
            changed: false
        }
    },
    components: {
        Editor
    },
    created () {
        this.documentTitle('Org Info')
        this.fetch()
    },
    methods: {
        fetch () {
            this.loading = true
            api.auth.organization.get()
                .then(org => {
                    this.orgSettings = org
                    delete this.orgSettings.logo
                    delete this.orgSettings.icon
                    this.loading = false
                })
        },
        save () { 
            this.saving = true
            this.orgSettings.info = this.$refs.htmlEditor.getHTML().replace(/<p>/g, "").replace(/<\/p>/g, "<br>").replace(/(<br>*)$/,'')
            api.auth.organization.save(this.orgSettings)
            .catch(() => {
                alert('Something went wrong attempting to update organization settings.')
                this.saving = false
            })
        }
    }
}

</script>

<style>
</style>